import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
const SESSION_KEY = 'visitorSessionId';

const getOrCreateSessionId = (): string => {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
};

// Analytics tracking is gated on the user's cookie consent (same rule as page views).
const hasAnalyticsConsent = (): boolean => {
  try {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) return false;
    return !!JSON.parse(consent).analytics;
  } catch {
    return false;
  }
};

// Track page view
export const trackPageView = async (path: string) => {
  try {
    if (!hasAnalyticsConsent()) return;
    const sessionId = getOrCreateSessionId();
    await axios.post(`${API_URL}/visitor/track-page-view`, { path, sessionId });
  } catch (error) {
    // Silently fail - don't break user experience if tracking fails
    console.debug('Page view tracking failed:', error);
  }
};

// Track a product view (feeds the admin "Ürün İlgi Haritası").
// Fire-and-forget via sendBeacon so it also survives tab close / navigation away,
// carrying the time spent on the product page. Sends at most once per call.
export const trackProductView = (productId: string, timeSpent = 0): void => {
  try {
    if (!productId || !hasAnalyticsConsent()) return;
    const sessionId = getOrCreateSessionId();
    const url = `${API_URL}/behavior-analytics/track`;
    const payload = {
      sessionId,
      eventType: 'product_view',
      data: { productId, timeSpent: Math.max(0, Math.round(timeSpent)) },
    };
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    } else {
      // Fallback: fire-and-forget POST (no await; must not block UI)
      axios.post(url, payload).catch(() => {});
    }
  } catch (error) {
    console.debug('Product view tracking failed:', error);
  }
};
